import * as React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from 'styled-components';
import { ThemeProvider as MuiProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import loadable from '@loadable/component';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// internal
import store from '@app/store';
import theme from '@app/assets/styles/colors';
import { muiTheme } from '@app/assets/styles/muiTheme';
import history from '@app/components/router/history';
import localization from '@app/locales/localization';
import RoutePrivate from '@app/components/router/private';
import { ProjectType } from '@app/store/typings/actions/project';
import { getToken, getProject } from '@app/utils/localStorage';
import { useProjectStore } from '@app/store/project';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const Account = loadable(() => import('@app/modules/account/routes'));
const ModuleApp = loadable(() => import('@app/app/module'));
const LoginHook = loadable(() => import('@app/modules/hook/container/LoginHook'));

if (getToken() && getProject()) {
  store.dispatch<ProjectType>({
    type: 'KEY_PROJECT_FETCH_WITHID',
    payload: '',
  });
}

/**
 * init project and state
 */
useProjectStore.getState().init();

const App: React.FC = () => {
  return (
    <>
      <Provider store={store}>
        <I18nextProvider i18n={localization}>
          <ThemeProvider theme={theme}>
            <MuiProvider theme={muiTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Router history={history}>
                  <Switch>
                    <Route exact path="/gateway/login" component={LoginHook} />
                    <RoutePrivate mode="unauth" path="/account" component={Account} />
                    <RoutePrivate mode="auth" path="/" component={ModuleApp} />
                  </Switch>
                </Router>
              </LocalizationProvider>
            </MuiProvider>
          </ThemeProvider>
        </I18nextProvider>
      </Provider>
    </>
  );
};

export default App;
